/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## Community chat client (hand-maintained to match the acacode
 * ## generated style). Regenerate with swagger-typescript-api if
 * ## the /Community contract changes.
 * ---------------------------------------------------------------
 */

import { ContentType, HttpClient, RequestParams } from "./http-client";

export class Community<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  channels = (params: RequestParams = {}) =>
    this.request<any, any>({ path: `/Community/Channels`, method: "GET", secure: true, ...params });

  messages = (channelId: string, query: { before?: string; take?: number } = {}, params: RequestParams = {}) =>
    this.request<any, any>({ path: `/Community/Channel/${channelId}/Messages`, method: "GET", query, secure: true, ...params });

  sendMessage = (channelId: string, data: { text: string; attachments?: any[] }, params: RequestParams = {}) =>
    this.request<any, any>({ path: `/Community/Channel/${channelId}/Message`, method: "POST", body: data, secure: true, type: ContentType.Json, ...params });

  editMessage = (messageId: string, data: { text: string }, params: RequestParams = {}) =>
    this.request<any, any>({ path: `/Community/Message/${messageId}`, method: "PUT", body: data, secure: true, type: ContentType.Json, ...params });

  deleteMessage = (messageId: string, params: RequestParams = {}) =>
    this.request<any, any>({ path: `/Community/Message/${messageId}`, method: "DELETE", secure: true, ...params });

  uploadImage = (channelId: string, file: File, params: RequestParams = {}) =>
    this.request<any, any>({ path: `/Community/Channel/${channelId}/Image`, method: "POST", body: { file }, secure: true, type: ContentType.FormData, ...params });
}
